import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../../models/hooks/appStateHooks';
import { invalidateAllContactAutomationsQueries } from '../../queries/useContactAutomationsQuery';

interface CancelAutomationStepVariables {
	stepStatusId: string;
}

export function useCancelAutomationStepMutation({
	impersonationContext,
	onSuccess,
	onError,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onSuccess?: (data: Api.IAutomationStepStatus, variables: CancelAutomationStepVariables) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		onSuccess: (data, variables) => {
			// Invalidate contact automations queries to refresh the UI
			invalidateAllContactAutomationsQueries();
			onSuccess?.(data, variables);
		},
		onError,
		mutationFn: ({ stepStatusId }: CancelAutomationStepVariables) => {
			return userSession.webServiceHelper.callAsync<Api.IAutomationStepStatus>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `Automation/Step/${encodeURIComponent(stepStatusId)}`,
				}),
				'DELETE',
				null
			);
		},
	});
}
